'use client'

import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

const VERIFY_TEXT = 'verify_this'
const VERIFY_SUFFIX = ' λ'

/** Inactive: typewriter "verify_this λ" for hero right column. Re-enable in section-hero by uncommenting <VerifyDisplay />. */
export function VerifyDisplay() {
  const [phase, setPhase] = useState<'cursor' | 'typing' | 'done'>('cursor')
  const [typed, setTyped] = useState('')
  const fullText = VERIFY_TEXT + VERIFY_SUFFIX

  useEffect(() => {
    const t = setTimeout(() => setPhase('typing'), 2800)
    return () => clearTimeout(t)
  }, [])

  useEffect(() => {
    if (phase !== 'typing') return
    if (typed.length < fullText.length) {
      const t = setTimeout(
        () => setTyped(fullText.slice(0, typed.length + 1)),
        90 + Math.random() * 50,
      )
      return () => clearTimeout(t)
    } else {
      const t = setTimeout(() => setPhase('done'), 400)
      return () => clearTimeout(t)
    }
  }, [phase, typed, fullText])

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: phase === 'done' ? 0 : 1 }}
      transition={{
        duration: phase === 'done' ? 2 : 0.6,
        delay: phase === 'done' ? 0 : 0.4,
      }}
      className="mt-58 hidden xl:flex xl:items-start xl:justify-start"
    >
      <div className="flex items-baseline gap-2 font-mono text-6xl whitespace-nowrap">
        <span className="text-white">
          {typed.slice(0, VERIFY_TEXT.length)}
          <span className="text-teal-300">
            {typed.slice(VERIFY_TEXT.length)}
          </span>
        </span>
        <span
          className="ml-px inline-block h-[1.15em] w-[3px] rounded-sm bg-white align-middle"
          style={{ animation: 'blink 0.6s step-end infinite' }}
        />
      </div>
    </motion.div>
  )
}
